import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext) {
  return this.sendEvent('contacts.settings.permissions', {})
}
